
import { Component, Mixins } from "vue-property-decorator";
import { ITimeSpanExpressionBehavior, TimeSpanKinds } from "../../../../../../documaker/domain/format/objects";
import { ITimeSpanExpressionBehaviorPropertyEditable, instanceOfITimeSpanExpressionBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class TimeSpanExpressionBehaviorPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: ITimeSpanExpressionBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITimeSpanExpressionBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isTimeSpanExpressionBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfITimeSpanExpressionBehaviorPropertyEditable(s) && s.timeSpanExpressionBehavior().isEditable(), false);
  }

  get timeSpanExpressionBehavior(): ITimeSpanExpressionBehavior {
    return this.readPropertyOrDefault(s => s.timeSpanExpressionBehavior().getValue(), { kind: TimeSpanKinds.DayHourMinute, from: null, to: null });
  }

  set timeSpanExpressionBehavior(value: ITimeSpanExpressionBehavior) {
    this.writePropertyWhenValid(s => s.timeSpanExpressionBehavior().setValue(value));
  }
}
